var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{ref:"listRef",class:_vm.baseClass,style:(`--items-per-row: ${_vm.itemsPerRow}`)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }